import Layout from '../../components/Layout';
import Seo from '../../components/Seo';
import { Flex, Text, Box, Divider } from '@chakra-ui/react';
import Button from '../../components/CustomButton';
import Partners from '../../components/Partners';
import { GET_PARTNERS } from '../../apollo/queries/GetPartners';
import { useQuery } from '@apollo/client';

const PartnersShowcase = ({ global }) => {
  // Load partners
  const partnersQueryRes = useQuery(GET_PARTNERS, {
    context: { clientName: 'strapi' },
    variables: {
      filters: {
        name: {
          eq: 'Partners',
        },
      },
      pagination: {
        pageSize: 100,
      },
    },
    fetchPolicy: 'cache-first',
  });

  let PARTNERS = null;

  if (!partnersQueryRes.loading) {
    PARTNERS = partnersQueryRes.data.lists.data[0].attributes;

    // Find all partners which have a shortDescription
    PARTNERS = PARTNERS.entities.data.filter(
      (item) => item.attributes.shortDescription
    );

    // Order partners based on their position
    PARTNERS = PARTNERS.sort((a, b) => {
      return a.attributes.position - b.attributes.position;
    });
  }

  return (
    <Layout global={global}>
      <Seo seo={{}} />
      <Box>
        <Box maxW={720} margin={'4rem auto'}>
          <Text fontSize="1.1rem" lineHeight="1.7" textAlign="center">
            Partner showcase
          </Text>
        </Box>
        <Box maxW={720} margin={'4rem auto'}>
          <Text fontSize="1.1rem" lineHeight="1.7">
            Anders Pink is plugged into leading partners and platforms to make
            it easier to embed content curation in your LMS, Learning Platform,
            or whatever tool you want. If you&apos;re already working with one
            of our partners - it&apos;s really easy. Contact any of our partners
            to learn more about how to get Anders Pink as part of your solution.
          </Text>
          <Box my={10} textAlign="center">
            <Button
              onClick={() => true}
              title="Become a partner"
              backgroundColor="#CF0032"
            />
          </Box>
          <Text
            fontSize="1.6rem"
            fontWeight="700"
            color="#006067"
            textAlign="center"
          >
            Our Partners and Platforms:
          </Text>
        </Box>
        <Box maxW={1150} margin={'4rem auto'}>
          {PARTNERS && (
            <Flex flexWrap="wrap" justifyContent="space-around">
              {PARTNERS.map((item, index) => (
                <Box key={index}>
                  <Partners item={item} />
                  {index !== PARTNERS.length - 1 && (
                    <Divider variant="solid" borderColor="#CF0032" />
                  )}
                </Box>
              ))}
            </Flex>
          )}
        </Box>
      </Box>
    </Layout>
  );
};

export default PartnersShowcase;
